import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import emailIcon from "../../../assets/svgs/emailIcon.svg";
import lockIcon from "../../../assets/svgs/lockIcon.svg";
import { CheckArrow } from "../../../assets/svgs/svg";
import Footer from "../../../components/Footer";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import ApiService from "../../../service/api";
import { showErrorToast } from "../../../utils/ToastsModal";
import { isValidEmail } from "../../../utils/modules";

const MailForm = () => {
  const emailRef = React.useRef(null);
  const navigate = useNavigate();
  const params = useParams();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorFocus, setEmailErrorFocus] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    if (!isValidEmail(email)) {
      emailRef.current.focus();
      setEmailError(true);
      setEmailErrorFocus(true);
      setSuccess(false);
    } else {
      setSuccess(true);
      const apiData = { email: email };
      await ApiService.addEmail(apiData)
        .then((response) => {
          if (response.status === 200) {
            ApiService.addTag("4643341", {
              api_secret: process.env.REACT_APP_CK_SECRET_KEY,
              email: email,
              first_name:
                params.gender !== "undefined" ? params.gender : "female",
            });

            setTimeout(() => {
              navigate(`/${params.gender}/weekPlan`, { state: email });
            }, 1000);
          }
        })
        .catch((err) => {
          showErrorToast(err?.response?.data);
        });
    }
  };

  useEffect(() => {
    if (isValidEmail(email) && emailErrorFocus) {
      setEmailError(false);
    } else if (emailErrorFocus) {
      setEmailError(true);
      emailRef.current.focus();
    }
  }, [email]);

  return (
    <>
      <MobileViewLayout>
        <div
          className="text-center flex-grow-1 d-flex flex-column px-4"
          style={{
            paddingTop: "50px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <p className="plan-text-big mb-0 fw-bold fs30">
            <Trans
              i18nKey={"email_signup.title"}
              components={{ tag: <span style={{ color: "#4286F5" }} /> }}
            />
          </p>

          <div className="d-flex justify-content-center align-items-center flex-column mt-4">
            <div className="email-input-wrapper" style={{ width: "100%" }}>
              <div className="email-input-icon">
                <img
                  src={emailIcon}
                  alt=""
                  className=""
                  style={{
                    width: "24px",
                    height: "20px",
                  }}
                />
              </div>
              <input
                ref={emailRef}
                required
                className="input-field email-input w-100"
                placeholder={t("email_signup.email_label")}
                onChange={(e) => {
                  setSuccess(false);
                  setEmail(e.target.value.toLowerCase());
                }}
                style={{ textTransform: email.length > 0 && "lowercase" }}
              />
              {
                <CheckArrow
                  className={`email-input-icon success-check-icon ${
                    success && "fade-in"
                  }`}
                />
              }
            </div>
            {emailError && (
              <p
                className="small align-self-start m-0 p-0"
                style={{ color: "red" }}
              >
                <Trans i18nKey={"email_signup.email_placeholder"} />
              </p>
            )}
            {!emailError && (
              <p
                className={`small align-self-start ${
                  success && "fade-in"
                } m-0 p-0`}
                style={{
                  color: "#009B24",
                  fontWeight: "500",
                  opacity: 0,
                  transition: "opacity 0.2s ease-in-out",
                }}
              >
                <Trans i18nKey={"email_signup.success_message"} />
              </p>
            )}
            <div className="d-flex flex-row justify-content-center align-items-start w-100 mt-4 plan-privacy-text px-1">
              <img src={lockIcon} alt="" style={{ marginTop: "5px" }} />
              <p className="mb-0 fw-semibold ">
                <Trans
                  i18nKey={"email_signup.privacy_note"}
                  components={{
                    tag: (
                      <span
                        style={{ textDecoration: "underline" }}
                        onClick={() => navigate("/privacy")}
                      />
                    ),
                  }}
                />
              </p>
            </div>
            <Button
              className="w-100 main-button py-3 fw-bold text-white mt-4 mb-1 bgSecondary"
              style={{ height: "60px" }}
              onClick={handleSubmit}
            >
              <Trans i18nKey={"common_text.continue"} />
            </Button>
          </div>
        </div>
      </MobileViewLayout>
      <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-end pt-3 px-0 pb-2 ">
        <hr style={{ width: "100%" }} />
        <Footer />
      </div>
    </>
  );
};

export default MailForm;
